import styled, { css } from 'styled-components';
import { focusVisibleMixin } from '@elfsight/widget-ui';
import {
  getHandleActionKeyDown,
  getInvertedColor
} from '@elfsight/widget-utils';
import { Icon } from '../common';

type PositionVariationType = 'bottom-right' | 'bottom-left' | 'top-right';

function getPosition(
  positionVariation: PositionVariationType,
  compact: boolean
) {
  const offset = compact ? 8 : 12;

  return {
    _elementTop: positionVariation.includes('top') ? offset : undefined,
    _elementRight: positionVariation.includes('right') ? offset : undefined,
    _elementBottom: positionVariation.includes('bottom') ? offset : undefined,
    _elementLeft: positionVariation.includes('left') ? offset : undefined
  };
}

interface PairSliderControlFullscreenProps {
  position: PositionVariationType;
  compact: boolean;
  backgroundColor?: string;
  onClick: () => void;
}

export function PairSliderControlFullscreen({
  position: positionVariation,
  compact,
  backgroundColor = '',
  onClick
}: PairSliderControlFullscreenProps) {
  const iconColor = getInvertedColor(backgroundColor, [
    'rgb(255, 255, 255)',
    'rgb(0, 0, 0)'
  ]);

  return (
    <Container
      {...getPosition(positionVariation, compact)}
      role="button"
      aria-label="Expand to full screen"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={getHandleActionKeyDown(onClick)}
      _elementBackgroundColor={backgroundColor}
    >
      <Icon type="fullscreen" color={iconColor} />
    </Container>
  );
}

const Container = styled.div<{
  _elementTop?: number;
  _elementRight?: number;
  _elementBottom?: number;
  _elementLeft?: number;
  _elementBackgroundColor?: string;
}>`
  position: absolute;
  z-index: 4;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 transparent;
  transition: box-shadow 0.4s ease;
  cursor: pointer;

  ${({
    _elementTop: top,
    _elementRight: right,
    _elementBottom: bottom,
    _elementLeft: left,
    _elementBackgroundColor: backgroundColor
  }) =>
    css({
      top,
      right,
      bottom,
      left,
      backgroundColor
    })};

  ${focusVisibleMixin}

  &:not(:active):hover {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
  }
`;
